import * as prismicH from '@prismicio/helpers'

import isPresent from './isPresent'

const prismicAsHtml = (richTextField) =>
  isPresent(prismicH.asText(richTextField)) ? prismicH.asHTML(richTextField) : null

export default prismicAsHtml
